import { render, staticRenderFns } from "./creatTag.vue?vue&type=template&id=f2797340&scoped=true"
import script from "./creatTag.vue?vue&type=script&setup=true&lang=js"
export * from "./creatTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creatTag.vue?vue&type=style&index=0&id=f2797340&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2797340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2797340')) {
      api.createRecord('f2797340', component.options)
    } else {
      api.reload('f2797340', component.options)
    }
    module.hot.accept("./creatTag.vue?vue&type=template&id=f2797340&scoped=true", function () {
      api.rerender('f2797340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/tag/creatTag.vue"
export default component.exports